/*
 * @Author: chj
 * @Date: 2024-10-16 10:14:30
 * @LastEditors: chj
 * @LastEditTime: 2024-10-16 14:43:26
 * @Description: 请填写简介
 */
import request from '@/utils/request'

export function getDynamic(query) {
  return request({
    url: '/cms/listCms',
    method: 'get',
    params: query,
  })
}

export function getDynamicDetail(query) {
  return request({
    url: '/cms/listCms',
    method: 'get',
    params: query
  })
}
